import Header from "./Header";
export default function Gallery({ event }) {
  return (
    <>
      <Header />
      <div className="bg-gradient-to-b from-[#dceaf5] to-white">
        <section>
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
            <header className="text-center">
              <p className="mx-auto mt-4 max-w-md text-gray-500">
                Explore moments captured during the Workshop including keynote
                sessions, panel discussions, networking activities, exhibition
                booths, and award recognitions.
              </p>
            </header>
            <div key={event.id} className="mb-4 mt-8 flex justify-center">
              <img
                src={event.gallery_link}
                alt="QR CODE FOR CONFERNECE PHOTOS"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
